import React from 'react';
import Icon from '~/components/atom/Icon';
import JustificationContainer from '~/components/atom/JustificationContainer';
import { Body } from '~/components/atom/Typography';
import { Link } from '~/components/molecule/Link';
import useImageAssets from '~/hooks/useImageAssets';

const text = {
  noAssetsAvailable: 'Er zijn geen assets beschikbaar.',
  goToBranding: 'Ga naar Huisstijl',
  toAddAsset: 'om een asset toe te voegen.',
};

export type Props = {};

const NoAssetsMessageContainer: React.FCC<Props> = () => {
  const assets = useImageAssets();

  if (assets.length > 0) {
    return null;
  }

  return (
    <JustificationContainer
      gap="xxs"
      align="center"
      padding={['xxxs', null, 'xxs']}
    >
      <Icon name="error" color={{ group: 'text', variant: 'light' }} />
      <Body
        size="s"
        margin={[null]}
        color={{ group: 'text', variant: 'light' }}
      >
        {text.noAssetsAvailable}{' '}
        <Link to={`/-/settings/brand`}>{text.goToBranding}</Link>{' '}
        {text.toAddAsset}
      </Body>
    </JustificationContainer>
  );
};

export default NoAssetsMessageContainer;
